import {Language} from "./i18n";
import {FlagItaly} from "../components/Components/Flags/FlagItaly";
import {FlagUnitedStates} from "../components/Components/Flags/FlagUnitedStates";

export const flags = {
    [Language.ENGLISH]: FlagUnitedStates,
    [Language.ITALIAN]: FlagItaly,
}
